module.exports = __webpack_public_path__ + "img/misionBack.57e13e92.jpg";